import { useBlocNext } from "@blac/react";
import type { FC } from "react";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import LoadingCubit from "src/state/LoadingCubit/LoadingCubit";
import { tracker } from "src/state/state";

const TrackPageViews: FC = () => {
  const location = useLocation();
  const [allLoading] = useBlocNext(LoadingCubit);
  const trackViewDebuff = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );
  const lastTrackUrl = useRef<string>("_none_");

  useEffect(() => {
    const isLoading = allLoading.length > 0;
    if (isLoading) {
      return;
    }

    clearTimeout(trackViewDebuff.current);

    trackViewDebuff.current = setTimeout(() => {
      if (lastTrackUrl.current === location.pathname) {
        return;
      }
      lastTrackUrl.current = location.pathname;

      tracker.trackPageView(location);
    }, 1000);

    return () => {
      clearTimeout(trackViewDebuff.current);
    };
  }, [allLoading, location.pathname]);

  return null;
};

export default TrackPageViews;
